import { HttpService } from '@maia/httpClient';
import { BaseService } from '@maia/feature-utils';
import { ConfigService } from '@maia/config';
import { ITeamEntity } from '../../entitites/team.entity';

export class TeamService extends BaseService {
  constructor(httpService: HttpService, configService: ConfigService) {
    super(httpService, configService);
  }

  public async findMany(path: string, search: Record<string, unknown>) {
    return this.getMany<ITeamEntity>(path, search, 'team');
  }

  public async find(guid: string) {
    return this.get<ITeamEntity>(guid, 'team');
  }
}
